import { render, staticRenderFns } from "./StatsPhoenix.vue?vue&type=template&id=788ace34&scoped=true&"
import script from "./StatsPhoenix.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenix.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenix.vue?vue&type=style&index=0&id=788ace34&prod&lang=scss&"
import style1 from "./StatsPhoenix.vue?vue&type=style&index=1&id=788ace34&prod&lang=css&"
import style2 from "./StatsPhoenix.vue?vue&type=style&index=2&id=788ace34&prod&lang=css&"
import style3 from "./StatsPhoenix.vue?vue&type=style&index=3&id=788ace34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ace34",
  null
  
)

export default component.exports